document.addEventListener 'DOMContentLoaded', ->
  hasValidZipcode = false

  searchDiv = document.querySelector ".search"
  searchBtn = document.querySelector ".search-button"
  errorMessageRadius = document.getElementById 'error-message-radius'
  errorMessageLocation = document.getElementById 'error-message-location'
  autoClickButton = document.getElementById 'auto-button-click'
  addressInput = document.getElementById 'find_technician_location'

  validateIntegerInput = (input) ->
    input.value = input.value.replace /\D/g, ''
    if input.value < 1
      input.value = ''

  autoButtonClick = ->
    if autoClickButton
      autoClickButton.click()

  printPlace = (input) ->
    place = input.getPlace()
    components = place.address_components;
    postalCode = components.some (component) -> component.types.includes 'postal_code'

    inputValue = place.name + " " + place.formatted_address
    searchDiv.style.display = 'block'
    
    return postalCode


  googleAutocomplete = initAutoComplete addressInput
  googleAutocomplete.addListener 'place_changed', -> 
    hasValidZipcode = printPlace this

  radiusInput = document.querySelector 'input[name="find_technician[radius]"]'
  locationInput = document.querySelector 'input[name="find_technician[location]"]'

  radiusInput.addEventListener 'input', -> validateIntegerInput radiusInput

  searchBtn.addEventListener 'click', (event) ->
    radiusValid = radiusInput.value >= 1
    locationValid = locationInput.value.trim() isnt ''

    if not radiusValid or not locationValid or not hasValidZipcode
      event.preventDefault()
      if not radiusValid
        errorMessageRadius.classList.remove 'hidden'
      else
        errorMessageRadius.classList.add 'hidden'

      if not locationValid or not hasValidZipcode
        errorMessageLocation.classList.remove 'hidden'
      else
        errorMessageLocation.classList.add 'hidden'

    else
      errorMessageRadius.classList.add 'hidden'
      errorMessageLocation.classList.add 'hidden'
      form = document.querySelector 'form'
      form.submit()

  autoButtonClick()
